const translations = {
    allUnits: 'All units',
    calibrationFlow: 'Flow',
    calibrationLevel: 'Level',
    calibrationMagnetometer: 'Magnetometer',
    calibrationPump: 'Pump',
    calibrationWeight: 'Weight',
    logService: 'Log service',
    serviceHistory: 'Service history',
    upcoming: 'Upcoming'
};

export default translations;
